import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-white.png'


const _withScopeId = n => (_pushScopeId("data-v-b20c3c68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "LoginContainer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo d'EHOP Voyage"
  })
], -1))
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidateToken = _resolveComponent("ValidateToken")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        id: "LoginForm",
        onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.OnSubmitClickHandler && _ctx.OnSubmitClickHandler(...args))),
        class: "init-fadein"
      }, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          id: "Username",
          type: "text",
          name: "Username",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          placeholder: _ctx.usernamePlaceholder
        }, null, 8, _hoisted_3), [
          [_vModelText, _ctx.username]
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Password",
          type: "password",
          name: "Password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          placeholder: _ctx.passwordPlaceholder
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.password]
        ]),
        (_ctx.errorLabel != '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errorLabel), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          id: "SubmitBtn",
          type: "submit",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.submitBtnValue) = $event))
        }, null, 512), [
          [_vModelText, _ctx.submitBtnValue]
        ])
      ], 32)
    ]),
    _createVNode(_component_ValidateToken, {
      onOnValidateEvent: _cache[4] || (_cache[4] = ($event: any) => (_ctx.OnValidateHandler($event)))
    })
  ], 64))
}